<div *ngIf="product != null; else loading">
  <div class="row product-detail mt-5">
    <div class="col-xs-12 col-sm-6">
      <div class="row">
        <div class="col-12 mb-2" *ngIf="!!product.extra.images">
          <div class="product-d-image">
            <ngb-carousel #myCarousel [interval]="-1" [showNavigationIndicators]="false" [showNavigationArrows]="false">
              <ng-template ngbSlide *ngFor="let image of product.extra.images; let i = index" [id]="imageIdString + i">
                <div class="square">
                  <div class="content">
                    <div class="d-flex justify-content-center align-items-flex-start">
                      <img
                        class="img-fluid"
                        src="https://cdn1.gung.io/fit-in/320x320/filters:fill(white):background_color(white):etag({{
                          image.s3ETag
                        }}):format(jpeg)/{{ image.s3Uri }}"
                        alt="{{ image.description }}"
                      />
                    </div>
                  </div>
                </div>
              </ng-template>
            </ngb-carousel>
          </div>
        </div>
        <div class="col-12" *ngIf="false && !!product.extra.images && product.extra.images.length > 1">
          <div class="scolling-images">
            <a class="scroll-left" (click)="scrollImagesLeft()" *ngIf="product.extra.images.length > 3">
              <i class="fa fa-2x fa-caret-left"></i>
            </a>
            <div class="scroll-container row" #scrollContainer>
              <div
                class="col-4 d-flex justify-content-center align-items-center"
                [ngClass]="{ 'pr-0': index == product.extra.images.length - 1 }"
                *ngFor="let image of product.extra.images; let i = index"
              >
                <img
                  (click)="select(i)"
                  class="img-fluid"
                  src="https://cdn1.gung.io/fit-in/150x150/filters:fill(white):background_color(white):etag({{
                    image.S3ETag
                  }}):format(jpeg)/{{ image.s3Uri }}"
                  alt="{{ image.description }}"
                />
              </div>
            </div>
            <a class="scroll-right" (click)="scrollImagesRight()" *ngIf="product.extra.images.length > 3">
              <i class="fa fa-2x fa-caret-right"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-12 col-sm-6">
      <div class="row">
        <div class="col-10">
          <h1>{{ product.name }}</h1>
        </div>
        <div class="col-auto ml-auto">
          <button type="button" class="btn btn-link m-0 p-0" onclick="window.print()" [title]="'PRINT' | translate">
            <i class="fa fa-print fa-lg"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>{{ getProductDescription() | async }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col h5">
          {{ product.extra.ar?.artbeskrspec }}
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <h3>
            <span>{{ 'ITEM_NO' | translate }}</span
            >: {{ product.id }}
          </h3>
        </div>
        <div class="col-6">
          <i class="fas fa-box product-availability-box-icon"></i>&nbsp;
          <lib-availability [availability]="availability"></lib-availability>
        </div>
      </div>

      <div class="row">
        <div class="col-12"></div>
      </div>
      <!-- <h5 class="product-title">{{ product.name }} - {{ product.id }}</h5> -->
      <div class="row">
        <div class="col-4 price-area" *ngIf="price.customerGrossPrice.value != price.customerNetPrice.value">
          <h4 [class.d-none]="hidePrice">
            <span>{{ 'GROSS_PRICE' | translate }}</span
            ><br />
            <strong>{{ price.customerGrossPrice.value | gungCurrency: price.customerGrossPrice.currencyCode }}</strong>
          </h4>
        </div>

        <div class="col-4 price-area" *ngIf="price.customerGrossPrice.value != price.customerNetPrice.value">
          <h4 [class.d-none]="hidePrice">
            <span>{{ 'DISCOUNT' | translate }}</span
            ><br />
            <span *ngIf="price.customerDiscountPercent !== 0"
              ><strong>(-{{ price.customerDiscountPercent }}%)</strong></span
            >
          </h4>
        </div>
        <div class="col-4 price-area">
          <h4 [class.d-none]="hidePrice">
            <span>{{ getNetPriceLabel(product) | async }}</span
            >:
            <strong>{{ getNetPriceValue(price) | gungCurrency: price.customerNetPrice.currencyCode }}</strong>
          </h4>
        </div>
      </div>

      <div class="row mt-2" *ngIf="!isOnlyDisplayFlow">
        <div class="col-12">
          <div class="detail-buy-button">
            <colmec-buy-btn
              [product]="product"
              [id]="product.id"
              [minimumOrderQuantity]="product.extra.ar.artfsgforp"
              [stepAmount]="product.extra.ar.artfsgforp"
            >
            </colmec-buy-btn>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col">
      <lib-gung-accordion 
        #acc="gungAccordion" 
        [destroyOnHide]="false" 
        class="accordion-jeeves-product-details">
        <lib-gung-accordion-item id="jeeves-product-details">
          <ng-template libGungAccordionHeader>{{ 'PRODUCT_DETAIL_PROPERTIES' | translate }}</ng-template>
          <ng-template libGungAccordionBody>
            <div class="row">
              <div class="col-6">
                <div class="table-responsive">
                  <table class="table table-borderless table-sm product-details-table">
                    <tbody>
                      <tr *ngIf="product.extra.ar.itemtypecd4">
                        <th class="product-details-table-first">
                          {{ 'AR_ITEMTYPECD4' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('atp4', 'itemtypedesc', product.extra.ar.itemtypecd4) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.itemtypecd5">
                        <th class="product-details-table-first">
                          {{ 'AR_ITEMTYPECD5' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('atp5', 'itemtypedesc', product.extra.ar.itemtypecd5) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_position">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_POSITION' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_position', 'q_positiondesc', product.extra.ar.q_position) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.itemtypecd1">
                        <th class="product-details-table-first">
                          {{ 'AR_ITEMTYPECD1' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('atp1', 'itemtypedesc', product.extra.ar.itemtypecd1) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.itemtypecd2">
                        <th class="product-details-table-first">
                          {{ 'AR_ITEMTYPECD2' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('atp2', 'itemtypedesc', product.extra.ar.itemtypecd2) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.itemtypecd3">
                        <th class="product-details-table-first">
                          {{ 'AR_ITEMTYPECD3' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('atp3', 'itemtypedesc', product.extra.ar.itemtypecd3) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_li">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_LI' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_li', 'q_lidesc', product.extra.ar.q_li) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_si">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_SI' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_si', 'q_sidesc', product.extra.ar.q_si) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-6">
                <div class="table-responsive">
                  <table class="table table-borderless table-sm product-details-table">
                    <tbody>
                      <tr *ngIf="product.extra.ar.q_bransleeff">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_BRANSLEEFF' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_bransleeff', 'q_bransleeffdesc', product.extra.ar.q_bransleeff) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_vatgrepp">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_VATGREPP' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_vatgrepp', 'q_vatgreppdesc', product.extra.ar.q_vatgrepp) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_bullervarde">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_BULLERVARDE' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_bullervarde', 'q_bullervardedesc', product.extra.ar.q_bullervarde) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_bullerklass">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_BULLERKLASS' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_bullerklass', 'q_bullerklassdesc', product.extra.ar.q_bullerklass) }}
                        </td>
                      </tr>
                      <tr>
                        <th class="product-details-table-first">
                          {{ 'AR_Q_MS' | translate }}
                        </th>
                        <td>
                          {{ getBooleanName(product.extra.ar.q_ms) }}
                        </td>
                      </tr>
                      <tr>
                        <th class="product-details-table-first">
                          {{ 'AR_Q_3PMSF' | translate }}
                        </th>
                        <td>
                          {{ getBooleanName(product.extra.ar.q_3pmsf) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_monsterdjup">
                        <th>
                          {{ 'AR_Q_MONSTERDJUP' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_monsterdjup', 'q_monsterdjupdesc', product.extra.ar.q_monsterdjup) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_bultcirkel">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_BULTCIRKEL' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_bultcirkel', 'q_bultcirkeldesc', product.extra.ar.q_bultcirkel) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_navhal">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_NAVHAL' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_navhal', 'q_navhaldesc', product.extra.ar.q_navhal) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_inpressning">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_INPRESSNING' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_inpressning', 'q_inpressningdesc', product.extra.ar.q_inpressning) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_bulthal">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_BULTHAL' | translate }}
                        </th>
                        <td>
                          {{ getOptionName('q_bulthal', 'q_bulthaldesc', product.extra.ar.q_bulthal) }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_maxbelastning">
                        <th class="product-details-table-first">
                          {{ 'AR_Q_MAXBELASTNING' | translate }}
                        </th>
                        <td>
                          {{
                            getOptionName('q_maxbelastning', 'q_maxbelastningdesc', product.extra.ar.q_maxbelastning)
                          }}
                        </td>
                      </tr>
                      <tr *ngIf="product.extra.ar.q_gung_eu">
                        <th class="product-details-table-first">
                          {{ 'Q_GUNG_EU' | translate }}
                        </th>
                        <td>
                          <a href="{{ product.extra.ar.q_gung_eu }}" target="_blank" translate>LINK</a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="col-6 col-md-3 flex-row-reverse d-flex">
                <colmec-product-symbols [product]="product"></colmec-product-symbols>
              </div>
            </div>
          </ng-template>
        </lib-gung-accordion-item>
      </lib-gung-accordion>
      <!-- <div class="mt-3">
        <lib-gung-accordion #acc2="gungAccordion" class="accordion-addons">
          <lib-gung-accordion-item id="addons">
            <ng-template libGungAccordionHeader>{{'PRODUCT_DETAIL_ADDONS' | translate}}</ng-template>
            <ng-template libGungAccordionBody>
              <lib-product-list-by-ids [productIds]="addonIds"></lib-product-list-by-ids>
            </ng-template>
          </lib-gung-accordion-item>
        </lib-gung-accordion>
      </div> -->
      <!-- <div class="mt-3">
        <lib-gung-accordion #acc3="gungAccordion" class="accordion-documents">
          <lib-gung-accordion-item id="documents">
            <ng-template libGungAccordionHeader>{{ 'PRODUCT_DETAIL_DOCUMENTS' | translate }}</ng-template>
            <ng-template libGungAccordionBody>
              <div class="row">
                <div class="col table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>{{'NAME' | translate}}</th>
                        <th class="text-right">{{'DOWNLOAD_DOCUMENT' | translate}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let document of product.extra.documents;">
                        <td>
                          {{document.i18n[currentLang].description}}
                        </td>
                        <td class="text-right">
                          <a target="_NEW"
                          [href]="'https://cdn2.gung.io/' + document.s3Uri + '?etag=' + document.s3ETag">
                          {{getFileName(document.s3Uri)}}
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-template>
          </lib-gung-accordion-item>
        </lib-gung-accordion>
      </div> -->
      <div class="related-products" *ngIf="pimRelatedProductsIds.length > 0">
        <h3>{{'PRODUCT_RELATED_PRODUCTS' | translate}}</h3>
        <lib-product-list-by-ids [productIds]="pimRelatedProductsIds"></lib-product-list-by-ids>
      </div>
    </div>
  </div>
</div>

<ng-template #loading> LOADING... </ng-template>
